import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Loading from './loading-omni-uhd.json'
import { useLottie } from 'lottie-react';
import { Box } from '@mui/material';



export default function LoadingWithBackDrop(props) {


  const Lottie = () => {

    const options = {
      animationData: Loading,
      loop: true
    }

    const { View: _view } = useLottie(options);

    return (
      <Box
        sx={{
          // marginTop: "30px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "8%",
        }}
      >
        {_view}
      </Box>
    )
  }


  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.open}
        invisible={props.invisible}
      >
        <Lottie />
      </Backdrop>
    </div>
  );
}